import React, { useEffect } from 'react';
import TextInput from 'components/UI/TextInput';
import { connect, useDispatch } from 'react-redux';
import { isValidCvc } from 'utilities/validators';
import { setCardCvc } from 'actions/NewPaymentMethod';
import { useTranslation } from 'react-i18next';
import './CheckoutCvc.scss';
function CheckoutCVC({ cvc }) {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    useEffect(() => {
        return () => {
            dispatch(setCardCvc(''));
        };
    }, []);
    return (React.createElement("div", { className: "checkout-cvc" },
        React.createElement(TextInput, { className: "checkout-cvc__cvc", label: "CVC", type: "tel", value: cvc, maxLength: 3, validator: isValidCvc, invalidHelp: t('paymentNewPaymentMethodFormCVCInvalid'), onChange: (val) => dispatch(setCardCvc(val)), required: true }),
        React.createElement("p", { className: "checkout-cvc__inputHelpText" }, t('paymentNewPaymentMethodFormCVCFillHelp'))));
}
const mapStateToProps = ({ newPaymentMethod }) => {
    return {
        cvc: newPaymentMethod.cvc,
    };
};
export default connect(mapStateToProps)(CheckoutCVC);
